<template>
  <div>
    <VirtualFenceMap />
  </div>
</template>
<script>
import store from "@/store/index";
import VirtualFenceMap from "./VirtualFenceMap";
export default {
  components: {
    VirtualFenceMap,
  },
  beforeRouteEnter(to, from, next) {
    let getVirtualFence = store.dispatch("virtualFence/GET_VIRTUAL_FENCE");
    Promise.all([getVirtualFence]).then(() => {
      next();
    });
  },
  data() {
    return {};
  },
};
</script>
